
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"18","cy":"18","r":"18","fill":"#ED3E9D"}}),_c('path',{attrs:{"d":"M21.6668 7.91666H10.6668C9.6585 7.91666 8.8335 8.74166 8.8335 9.74999V22.5833H10.6668V9.74999H21.6668V7.91666ZM24.4168 11.5833H14.3335C13.3252 11.5833 12.5002 12.4083 12.5002 13.4167V26.25C12.5002 27.2583 13.3252 28.0833 14.3335 28.0833H24.4168C25.4252 28.0833 26.2502 27.2583 26.2502 26.25V13.4167C26.2502 12.4083 25.4252 11.5833 24.4168 11.5833ZM24.4168 26.25H14.3335V13.4167H24.4168V26.25Z","fill":"white"}})])
          )
        }
      }
    